export const EASE = 'easeOut'
